<ng-template vdrDialogTitle>
    <ng-container>{{
        'shopping-list.product-list.assign-product-to-shopping-list' | translate
    }}</ng-container>
</ng-template>

<!-- Tabela com todas as listas de compras para selecionar -->
<vdr-data-table-2
    id="partner-list-table"
    class="mt-2"
    [items]="items$ | async"
    [itemsPerPage]="itemsPerPage$ | async"
    [totalItems]="totalItems$ | async"
    [currentPage]="currentPage$ | async"
    (pageChange)="setPageNumber($event)"
    (itemsPerPageChange)="setItemsPerPage($event)"
>
    <!-- Menu de ações em massa -->
    <vdr-bulk-action-menu
        locationId="partner-list"
        [hostComponent]="this"
        [selectionManager]="selectionManager"
    >
    </vdr-bulk-action-menu>

    <!-- Coluna de checkbox de seleção -->
    <vdr-dt2-column id="select">
        <ng-template let-shoppingList="item">
            <clr-checkbox
                [clrChecked]="selectionManager.isSelected(shoppingList)"
                (clrCheckedChange)="toggleSelection(shoppingList)"
            >
            </clr-checkbox>
        </ng-template>
    </vdr-dt2-column>

    <vdr-dt2-column [heading]="'ID'" id="id">
        <ng-template let-shoppingList="item">
            {{ shoppingList.id }}
        </ng-template>
    </vdr-dt2-column>

    <!-- Colunas da Tabela -->
    <vdr-dt2-column
        [heading]="'shopping-list.table-columns.name' | translate"
        id="name"
        [optional]="false"
    >
        <ng-template let-shoppingList="item">
            <a class="button-ghost">
                {{ shoppingList.name }}
            </a>
        </ng-template>
    </vdr-dt2-column>

    <vdr-dt2-column [heading]="'common.enabled' | translate" id="enabled">
        <ng-template let-shoppingList="item">
            <vdr-chip *ngIf="shoppingList.enabled" colorType="success">{{
                'common.enabled' | translate
            }}</vdr-chip>
            <vdr-chip *ngIf="!shoppingList.enabled" colorType="warning">{{
                'common.disabled' | translate
            }}</vdr-chip>
        </ng-template>
    </vdr-dt2-column>

    <vdr-dt2-column [heading]="'Token'" id="token">
        <ng-template let-shoppingList="item">
            {{ shoppingList.token }}
        </ng-template>
    </vdr-dt2-column>
</vdr-data-table-2>

<!-- Botões de cancelar/enviar -->
<ng-template vdrDialogButtons>
    <button type="button" class="btn" (click)="cancel()">
        {{ 'common.cancel' | translate }}
    </button>
    <button
        type="submit"
        (click)="assign()"
        [disabled]="selectionManager.selection.length < 1"
        class="btn btn-primary"
    >
        <div *ngIf="selectionManager.selection.length < 1">
            {{ 'shopping-list.product-list.button-assign-empty' | translate }}
        </div>
        <div *ngIf="selectionManager.selection.length == 1">
            {{ 'shopping-list.product-list.button-assign-one' | translate }}
        </div>
        <div *ngIf="selectionManager.selection.length > 1">
            {{
                'shopping-list.product-list.button-assign'
                    | translate
                        : {
                              count: selectionManager.selection.length
                          }
            }}
        </div>
    </button>
</ng-template>
